import { type Offer } from "@core/offers/types";
import { trans, plainTrans } from "@mongez/localization";
import { OffersList } from "../../components";

interface OffersListPageContentProps {
  offers: Offer[];
}

export function OffersListPageContent({ offers }: OffersListPageContentProps) {
  return (
    <div className="app-page-canvas pb-14">
      <div className="container mx-auto max-w-[90rem] px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
        <OffersList
          offers={offers}
          title={plainTrans("offers.title")}
          description={trans("offers.description")}
        />
      </div>
    </div>
  );
}
